import Vue from 'vue';
import Router from 'vue-router';

import Landing from '@/views/Landing.vue';
import PinSet from '@/views/PinSet.vue';
import Success from '@/views/Success.vue';
import Failure from '@/views/Failure.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing,
    },
    {
      path: '/pin-set/success',
      name: 'success',
      component: Success,
      props: (route) => ({ code: route.query.r })
    },    
    {
      path: '/pin-set/failure',
      name: 'failure',
      component: Failure,
      props: (route) => ({ code: route.query.r, error: route.query.e })
    },      
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
